/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
// import ReactHtmlParser from 'react-html-parser';
import 'react-datepicker/dist/react-datepicker.css';
import parse from 'html-react-parser';
import { useDispatch, useSelector } from 'react-redux';
import useApi from '../hooks/useApi';
import convertToCurrency from '../helpers/convertToCurrency';
import stringifyArray from '../helpers/stringifyArray';
import { segmentEvent } from '../helpers/sendEvent';
import ErrorHandling from '../components/ErrorHandling/index';
import SubmitButton from '../components/SubmitButton';
import useListenSize from '../hooks/useListenSize';
import { confirmWarrantyAgreement } from '../redux/actions';
import sanitizeContractHtml from '../helpers/sanitizeContractHtml';

const goBackToRetailor = () => {
  const payload = JSON.parse(
    JSON.stringify({
      katapultSDK: 'payment-fail',
      payload: {
        message: 'Declined Warranty Agreement',
      },
    }),
  );
  window?.parent?.postMessage(payload, '*');
};

// eslint-disable-next-line no-shadow
function WarrantyAgreement() {
  const { handleSubmit, register, watch } = useForm({ mode: 'onChange' });
  const { request, response, error, loading } = useApi();

  const dispatch = useDispatch();
  const store = useSelector(state => ({
    warranty_names: state?.loanInfo?.checkout?.warranty_names,
    payFrequency: state?.loanInfo?.payFrequency,
    warranty_payment_total: state?.loanInfo?.checkout?.warranty_payment_total,
    checkoutUid: state?.loanInfo?.checkoutUid,
    shopify: state.technical?.shopify,
    checkoutLookupData: state.personal?.checkoutLookupData,
    new_user_pay_freq: state.personal?.newUserDetails?.payment_frequency,
  }));

  const agreement = watch('agreeWarranty');
  useEffect(async () => {
    await request.getWarrantyContract(store.checkoutUid);
    segmentEvent('page', 'Warranty Agreement');
  }, []);

  const history = useHistory();
  useListenSize();

  const goToCancelUrl = () => {
    window.location.href = store.checkoutLookupData?.checkout_object?.urls?.cancel;
  };

  const onSubmit = ({ agreeWarranty }) => {
    segmentEvent('track', 'Warranty Agreement Select', {
      agree: agreeWarranty,
    });
    if (agreeWarranty === 'no') {
      if (store.shopify?.isShopify) {
        goToCancelUrl();
      } else {
        goBackToRetailor();
      }
    }
    if (agreeWarranty === 'yes') {
      dispatch(confirmWarrantyAgreement());
      history.push('/display-offered-lease-details');
    }
  };

  return (
    <div className="k-content-wrapper">
      <ErrorHandling response={response} error={error} />
      <section className="k-info">
        <h1>Congratulations, Katapult is offering you additional benefits!</h1>
        <p>
          Katapult is offering you additional rights and benefits associated with the{' '}
          {stringifyArray(store.warranty_names)} in your cart. While Katapult does not offer the{' '}
          {stringifyArray(store.warranty_names)} as a stand-alone item, we can provide you the{' '}
          {stringifyArray(store.warranty_names)} as part of a Liability Damage Waiver for no additional cost. You will
          pay {convertToCurrency(store.warranty_payment_total)}{' '}
          {store.shopify?.isShopify ? store.new_user_pay_freq : store.payFrequency} for the Liability Damage Waiver but{' '}
          will receive all of the benefits of the {stringifyArray(store.warranty_names)}. Under the Liability Damage
          Waiver, Katapult will waive any right it may have against you for certain types of loss or damage to the
          leased property, see below terms and conditions.
        </p>
      </section>
      <section className="k-info k-info-contract k-info-contract-static">
        {response && response.data && parse(sanitizeContractHtml(response.data.contract))}
      </section>
      <section className="k-form k-form-indent">
        <form onSubmit={handleSubmit(onSubmit)}>
          <label className="block-label">
            <input type="radio" name="agreeWarranty" value="yes" {...register('agreeWarranty')} />
            ACCEPT: I have read and I agree to the terms and conditions above and would like to proceed to checkout
          </label>
          <label className="block-label">
            <input type="radio" name="agreeWarranty" value="no" {...register('agreeWarranty')} />
            REJECT: I do not agree to the terms and conditions above and would like to return to the shopping cart and
            remove the {stringifyArray(store.warranty_names)}
          </label>
          <SubmitButton
            grey={!agreement}
            text={!agreement || agreement === undefined || agreement === 'yes' ? 'Continue' : 'Return'}
            color={agreement === undefined ? '#DCDCDC' : false}
            loading={loading}
          />
        </form>
      </section>
    </div>
  );
}

export default WarrantyAgreement;
